<template>
  <div class="container">
    <div ref="arrowsEl" class="flicking-arrows mb-3 flex justify-end gap-4">
      <button class="flicking-arrow-prev">
        <SpriteSymbol name="chevron-left" class="size-size-4" />
      </button>
      <button class="flicking-arrow-next">
        <SpriteSymbol name="chevron-right" class="size-size-4" />
      </button>
    </div>

    <div ref="el" class="flicking-viewport !overflow-visible">
      <div class="flicking-camera">
        <BlokkliItem
          v-for="(item, index) in items"
          :key="item.uuid"
          v-bind="item"
          parent-type="slider"
          :index="index"
          class="mr-6 w-full tablet:w-[600px] desktop:w-[800px]"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FieldListItem } from '#blokkli/types'
import { getFlickingPlugin } from '~/helpers/flicking/plugins'

defineProps<{
  items: FieldListItem[]
}>()

const el = ref<HTMLDivElement>()
const arrowsEl = ref<HTMLDivElement>()

await useFlicking(el, {
  flickingOptions: {
    align: 'prev',
  },
  plugins: async () => {
    if (arrowsEl.value) {
      const Arrow = await getFlickingPlugin('Arrow')
      return new Arrow({
        parentEl: arrowsEl.value,
      })
    }

    return []
  },
})
</script>
